module.exports = __webpack_public_path__ + "img/sound_off.678d2fe2.png";